import React from 'react';
import { THEME_NAMES } from 'selectors/tag.selectors';
import { ItemTags } from 'views/shared/ItemTags';
import TemplateFormInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '300px',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Total Activities',
        dataIndex: 'activities.length',
        align: 'center',
        sorter: false
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the template
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: 'Templates',
    showFilter: true
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Template',
    title: 'Template',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <TemplateFormInput
            {...props}
            title="Template"
          />
        )
      },
      {
        key: 1,
        title: 'Tags',
        component: props => (
          <ItemTags
            {...props}
            themeName={THEME_NAMES.template}
          />
        )
      }
    ]
  }
};

export default config;
